import { DownloadOutlined } from '@ant-design/icons'
import { Space } from 'antd'
import Button from 'app/components/UI-Elements/General/Button'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { URLBuilderWithCustomer } from 'app/lib/URLBuilder'
import React from 'react'

import { FilterParams } from './OverView/Table'

type Props = {
  filters: FilterParams
}

const ExportButton: React.FC<Props> = ({ filters }) => {
  const { tButtonTitle } = useTranslation({ recordType: RecordType.invoice })
  const url = new URLBuilderWithCustomer().build('invoices/export.csv', filters)

  return (
    <Space>
      <Button
        onClick={() => window.open(url.toString())}
        title={tButtonTitle({ id: 'export' })}
        type="secondary"
        icon={<DownloadOutlined />}
      />
    </Space>
  )
}

export default ExportButton
